import { BseDto } from "../../autogen/bff-api";

export const eventIsAwarded = (event: BseDto): boolean => {
  return event.status === "Awarded";
};
